import {PriceStrategy} from "../input/PriceStrategy";

export const PriceStrategyValueFilter = "tfStrategyValueFormat";

export function priceStrategyValueFilter() {
    return (input: number | null, strategy: PriceStrategy) => {
        if (input == null || strategy == null) {
            return null;
        } else {
            return strategy.formatValue(input);
        }
    };
}
